import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './Doc.module.css';
import { noteActions, patientActions, dashboardActions } from '_actions'
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { getDateMDYYYY } from '_helpers'
import { FotoButton, StatusGood, InProgButton, FileButton, SaveButton, CancelButton, PdfButton, ReopenButton, SupervisorButton, LoadingIcon } from '_components';
import { pdfService } from '_services';

class PatientHomeCdvDoc extends React.Component {

    constructor() {
        super();
        this.state = {
            addendum: "",
        };
        this.showAddendum = this.showAddendum.bind(this);
        this.hideAddendum = this.hideAddendum.bind(this);
        this.deleteNote = this.deleteNote.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.saveAddendum = this.saveAddendum.bind(this);
    }

    handleChange(event) {
        this.setState({ addendum: event.target.value });
    }

    showAddendum(event) {
        this.props.showAddendum({ ptno: this.props.doc.ptno, noteId: this.props.doc.id });
        event.stopPropagation();
    }

    hideAddendum(event) {
        this.props.hideAddendum({ ptno: this.props.doc.ptno, noteId: this.props.doc.id });
        event.stopPropagation();
    }

    deleteNote(event) {
        this.props.deleteNote(this.props.doc.id);
        event.stopPropagation();
    }

    reopenNote(event) {
        this.props.reopenNote(this.props.doc.id, this.props.ptno);
        if (this.props.tab !== undefined && this.props.doc.id === this.props.tab.noteId) {
            this.props.closeTab({ tabId: this.props.tab.id, ptno: this.props.tab.ptno, noteId: this.props.tab.noteId });
        }

        event.stopPropagation();
    }

    saveAddendum(event) {
        this.props.saveAddendum(this.props.doc.id, this.state.addendum);
        this.setState({ addendum: "" });
    }

    openPdf() {
        let newWindow = window.open('/loading.html');
        newWindow.onload = () => {
            pdfService.raw(this.props.doc.id, this.props.docRenderType)
                .then(response => response.blob())
                .then(blobby => {
                    let objectUrl = window.URL.createObjectURL(blobby);
                    newWindow.location = objectUrl;
                });
        }
    }

    getIcon1() {
        switch (this.props.doc.noteType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 22:
                if (this.props.doc.status === 1 || this.props.doc.status === 5)
                    return (<InProgButton size='extra-small' title='In-Progress' />);
                else if (this.props.doc.status === 3)
                    return (<StatusGood size='extra-small' title='Awaiting Approval' className={styles.awaiting_approval_button} />)
                else
                    return (<StatusGood size='extra-small' title='Complete' />)
            case 13:
            case 14:
            case 15:
            case 16:
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:
                return (<FotoButton size='extra-small' />);
            default:
                return (<span />);
        }
    }


    getIcon2() {
        switch (this.props.doc.noteType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 22:
                if ((this.props.doc.status === 1 || this.props.doc.status === 5) && this.props.doc.addUser === this.props.urno && this.props.doc.hasCharges === false)
                    return (<CancelButton size='extra-small' title='Delete Note' onClick={(e) => this.deleteNote(e)} />);
                else if (this.props.doc.status === 1 || this.props.doc.status === 5)
                    return (<span />);
                else
                    return (<FileButton size='extra-small' title='Create Addendum' onClick={(e) => this.showAddendum(e)} />)
            default:
                return (<span />);
        }
    }

    getIcon3() {
        switch (this.props.doc.noteType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 22:
                if (this.props.doc.status === 2)
                    return (<PdfButton size='extra-small' title='Open PDF' onClick={(e) => this.openPdf()} />);
                else
                    return (<span />);
            default:
                return (<span />);
        }
    }

    getIcon4() {
        switch (this.props.doc.noteType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 22:
                if (this.props.doc.status !== 1 && this.props.doc.status !== 5)
                    return (<ReopenButton size='extra-small' title='Reopen Note' onClick={(e) => this.reopenNote(e)} color='blue' />);
                else
                    return (<span />);
            default:
                return (<span />);
        }
    }

    getIcon5() {
        switch (this.props.doc.noteType) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 22:
                if (this.props.doc.status === 3 && this.props.doc.addUser === this.props.urno)
                    if (!this.props.therapistRefreshing) {
                        return (<SupervisorButton size='extra-small' title='Update Supervisor' className={styles.supervisior_button} icon={faUserCircle} onClick={() => this.props.showSupervisors(this.props.doc)} />)
                    } else {
                        <LoadingIcon size="small" />
                    }
                else
                    return (<span />);
            default:
                return (<span />);
        }
    }



    hideScribe() {
        this.props.hideScribe({ ptno: this.props.doc.ptno, noteId: this.props.doc.id });
    }


    openDoc() {
        if ((this.props.doc.status === 1 || this.props.doc.status === 5) && this.props.source === 1) {
            if (this.props.doc.addUser !== this.props.urno) {
                this.props.showScribe({ ptno: this.props.doc.ptno, noteId: this.props.doc.id });
            } else {
                this.props.openInProg(this.props.doc.id, this.props.doc.ptno, this.props.doc.epno);
            }
        } else {
            this.props.openPdf(this.props.doc.id, true, this.props.docRenderType);
        }
    }

    scribe() {
        this.props.hideScribe({ ptno: this.props.doc.ptno, noteId: this.props.doc.id });
        this.props.openInProg(this.props.doc.id, this.props.doc.ptno, this.props.doc.epno);

    }

    preview() {
        this.props.hideScribe({ ptno: this.props.doc.ptno, noteId: this.props.doc.id });
        this.props.openPdf(this.props.doc.id);
    }

    render() {
        return (
            <div>
                <div className={styles.doc_wrapper} onClick={() => this.openDoc()}>
                    <div className={styles.doc_row}>
                        <div className={styles.icon}>
                            {this.getIcon1()}
                        </div>
                        <div className={styles.icon}>
                            {this.getIcon2()}
                        </div>
                        <div className={styles.iconSpace}>
                            {this.getIcon3()}
                        </div>
                        <div className={styles.icon}>
                            {this.getIcon4()}
                        </div>
                        <div className={styles.supervisior_icon} onClick={(e) => e.stopPropagation()}>
                            {this.getIcon5()}
                        </div>

                        <div className={styles.doc_name}>
                            {this.props.noteType}
                        </div>
                        <div className={styles.doc_dos}>
                            <span className={styles.inline_header}>DOS:</span>{this.props.doc.dos ? getDateMDYYYY(this.props.doc.dos) : ''}
                        </div>
                        <div className={styles.doc_visit}>
                            {this.props.doc.visitNum !== 0 &&
                                <span><span className={styles.inline_header}>Visit:</span>{this.props.doc.visitNum}</span>
                            }
                        </div>
                        <div className={styles.doc_therapist}>
                            {this.props.doc.therapist &&
                                <span><span className={styles.inline_header}>Therapist:</span>{this.props.doc.therapist}</span>
                            }
                        </div>
                    </div>
                </div>
                {this.props.addendumVisible &&
                    <div className={styles.addendum_wrapper}>
                        <div className={styles.addendum_header}>Addendum:</div>
                        <div className={styles.addendum_body}>
                            <div className={styles.addendum_input}>
                                <textarea autoFocus name="addednum" type="text" className={styles.addendum} rows="3" value={this.state.addendum} onChange={this.handleChange} />
                            </div>
                            <div className={styles.addendum_buttons}>
                                <span className={styles.addendum_button}><SaveButton onClick={this.saveAddendum} /></span>
                                <span className={styles.addendum_button}><CancelButton onClick={this.hideAddendum} /></span>
                            </div>
                        </div>
                    </div>
                }
                {this.props.scribeVisible &&
                    <div className={styles.scribe_wrapper}>
                        <div className={styles.scribe_header}>{'This note was originated by ' + this.props.doc.therapist + '. Would you like to scribe on this note?'}</div>
                        <div className={styles.scribe_body}>
                            <div className={styles.scribe_row}>
                                <span className={styles.scribe_button}><StatusGood size='extra-small' title='Scribe' onClick={() => this.scribe()} /></span>
                                <label className={styles.scribe_label} onClick={() => this.scribe()}>Scribe</label>
                            </div>
                            <div className={styles.scribe_row}>
                                <span className={styles.scribe_button}><PdfButton size='extra-small' title='Preview' onClick={() => this.preview()} /></span>
                                <label className={styles.scribe_label} onClick={() => this.preview()}>Preview</label>
                            </div>
                            <div className={styles.scribe_row}>
                                <span className={styles.scribe_button}><CancelButton title='Cancel' size='extra-small' onClick={() => this.hideScribe()} /></span>
                                <label className={styles.scribe_label} onClick={() => this.hideScribe()}>Cancel</label>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showAddendum: bindActionCreators(noteActions.showAddendum, dispatch),
        hideAddendum: bindActionCreators(noteActions.hideAddendum, dispatch),
        showScribe: bindActionCreators(noteActions.showScribe, dispatch),
        hideScribe: bindActionCreators(noteActions.hideScribe, dispatch),
        saveAddendum: bindActionCreators(noteActions.saveAddendum, dispatch),
        deleteNote: bindActionCreators(noteActions.deleteNote, dispatch),
        reopenNote: bindActionCreators(noteActions.reopenNote, dispatch),
        openPdf: bindActionCreators(patientActions.openPdf, dispatch),
        openInProg: bindActionCreators(noteActions.openInProgNote, dispatch),
        closeTab: bindActionCreators(patientActions.closeTab, dispatch),
        loadUserPreferences: bindActionCreators(dashboardActions.loadUserPreferences, dispatch),
    };
}


function mapStateToProps(state, ownprops) {
    let noteTypeID = parseInt(ownprops.id.split("_")[0]);
    let docRenderType = (state.entities.masterData.PROPS ? (state.entities.masterData.PROPS['SAPPHIRE_SEPARATE_POC_ENABLED'].PRVALUE === 'true' ? 3 : 1) : 1);
    let tab = state.ui.patientTabs["PDF_" + state.entities.cdv[ownprops.id].id];
    let doc = state.entities.cdv[ownprops.id];
    let therapistRefreshing = state.ui.cdv[doc.epno].therapistRefreshing;
    return {
        doc: doc,
        noteType: state.entities.masterData.PTMASTERNOTETYPES[state.entities.cdv[ownprops.id].noteType].MTNAME,
        source: state.entities.masterData.PTMASTERNOTETYPES[state.entities.cdv[ownprops.id].noteType].MTSONO,
        addendumVisible: state.ui.cdvOptions[state.ui.patients.selectedPtno].addendumVisible && state.ui.cdvOptions[state.ui.patients.selectedPtno].addendumDoc === ownprops.id,
        scribeVisible: state.ui.cdvOptions[state.ui.patients.selectedPtno].scribeVisible && state.ui.cdvOptions[state.ui.patients.selectedPtno].scribeDoc === ownprops.id,
        urno: state.entities.authentication.user.urno,
        ptno: state.ui.patients.selectedPtno,
        noteTypeID,
        tab,
        docRenderType,
        therapistRefreshing
    };
}

const connectedPatientHomeCdvDoc = connect(mapStateToProps, mapDispatchToProps)(PatientHomeCdvDoc);
export { connectedPatientHomeCdvDoc as PatientHomeCdvDoc };

